import { __moduleExports as decode_codepoint } from '../node_modules/entities/lib/decode_codepoint.js';

var require$$2 = decode_codepoint;

export { require$$2 as default };
